module.exports = __webpack_public_path__ + "img/close-icon.e76f5f0d.svg";